import { connect } from 'react-redux'
import TableView from './../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { useSearchParams } from 'react-router-dom'
import { callCheckInitializeListGet, callCheckInitializePost } from './../../actions/check-initialize'
import moment from 'moment'
import Swal from 'sweetalert2'
import Helper from '../../../../Helper'

let CheckInitializeFinishedList = ({ setPageAttr, list, methods: { callCheckInitializeListGet, callCheckInitializePost } }) => {
    let [searchParams] = useSearchParams();
    let initialized = list.initialized

    const showReason = (item) => {
        Swal.fire({
            html: `<div style="font-weight:bold;text-align:left;">Motivos do status:</div><div style="width:200px;text-align:left;margin-top:15px;">${Helper.nl2br(item.reason)}</div>`
        })
    }

    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'info',
            name: 'company',
            align: 'left',
            label: 'Empresa'
        },
        {
            type: 'info',
            name: 'region',
            align: 'left',
            label: 'Região'
        },
        {
            type: 'info',
            name: 'code',
            align: 'right',
            label: 'Código'
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'info',
            name: 'category',
            align: 'left',
            label: 'Categoria'
        },
        {
            type: 'info',
            name: 'user',
            align: 'left',
            label: 'Usuário'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Status',
            custom: (a) => {
                switch (a.status) {
                    case 'active':
                        return <span className='btn btn-sm btn-success'>ATIVO</span>
                    case 'inactive':
                        return (
                            <>
                                <span className='btn btn-sm btn-danger mr-1'>INATIVO</span>
                                <button type='button' title='Motivos' className='btn btn-sm btn-warning rounded rounded-circle' onClick={_=>showReason(a)}><i className='fas fa-info'></i></button>
                            </>
                        )
                    default:
                        return <>Error</>

                }
            }
        },
        {
            type: 'datetime',
            name: 'dateCheck',
            align: 'right',
            label: 'Verificado Em'
        },
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callCheckInitializeListGet({
            pending: 0
        }, pg)
    }, [callCheckInitializeListGet, searchParams])

    useEffect(() => {
        let labelInfo = 'Iniciei a checagem'
        if (initialized) {
            labelInfo = 'Iniciado em: ' + moment(initialized.replace(/T/igm, ' ').replace(/Z/igm, '')).format("DD/MM/YYYY HH:mm")
        }

        setPageAttr({
            title: 'Checks Operacionais - Útimos Finalizados',
            caption: 'Marque o status dos locais informados até finalização da lista',
            btns: [
                {
                    type: 'info',
                    class: 'btn btn-warning',
                    label: labelInfo,
                }
            ],
            tabs: [
                {
                    active: false,
                    to: '/checks-initialize',
                    label: 'Pendentes'
                },
                {
                    active: true,
                    to: '/checks-initialize/finished',
                    label: 'Útimos Finalizados'
                }
            ]
        })
    }, [setPageAttr, initialized])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/checks-initialize'} />
    )
}

const mapStateToProps = ({ check: { checkInitialize: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCheckInitializeListGet,
            callCheckInitializePost
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckInitializeFinishedList)